module.exports = {
    limit: 10,
    // Make provider url
    generateUrl: function fn() {
        let querystring = '';

        if (this.parameters) {
            Object.keys(this.parameters).forEach(key => {
                querystring += `&${key}=${this.parameters[key]}`;
            });
        }

        return `${this.remoteUrl}${querystring}`;
    },
    // Get icon from component body by class name
    getIconByClassName: function fn(element, className) {
        if (element && className) {
            const iconElement = element.querySelector(className);

            if (iconElement) {
                return iconElement.outerHTML;
            }
        }

        return '';
    },
    propertiesToSelect: {
        value: '',
        content: '',
        type: '',
        latlon: ''
    },
    // Should be the function that configure the typeahead.js
    configure: false,
    transform: false
};
